import { NETWORKS, type NetworkId } from '@onyx/shared';
import { NETWORK_COLOR } from '../lib/networks';

/** The network's official logo (public/icons/networks), clipped to a disc. */
export function NetworkMark({ network, size = 40 }: { network: NetworkId; size?: number }) {
  return (
    <span className="netmark" style={{ width: size, height: size, ['--net' as string]: NETWORK_COLOR[network] }} aria-hidden="true" title={NETWORKS[network].name}>
      <img src={`/icons/networks/${network}.svg`} width={size} height={size} alt="" draggable={false} />
    </span>
  );
}
